import { Button, Modal } from "react-bootstrap";
import "./FilePreviewModal.css";

const getFileName = (url) => {
  if (!url) return "attachment";

  try {
    const pathname = new URL(url, window.location.origin).pathname;
    const name = decodeURIComponent(pathname.split("/").pop() || "");
    return name || "attachment";
  } catch {
    const parts = String(url).split("/");
    return decodeURIComponent(parts[parts.length - 1] || "attachment");
  }
};

const FilePreviewModal = ({ preview, onClose }) => {
  const isImage = preview?.isImage;
  const title = preview?.title || "Attachment Preview";
  const fileName = getFileName(preview?.url);

  return (
    <Modal
      show={!!preview}
      onHide={onClose}
      size="lg"
      centered
      backdrop="static"
      className="vz-file-preview"
      dialogClassName="vz-file-preview__dialog"
    >
      <Modal.Header closeButton className="vz-file-preview__header border-0">
        <div className="vz-file-preview__header-inner">
          <span className={`vz-file-preview__header-icon ${isImage ? "vz-file-preview__header-icon--image" : ""}`}>
            <i className={`fas ${isImage ? "fa-image" : "fa-file-alt"}`} aria-hidden="true" />
          </span>
          <div className="vz-file-preview__header-text">
            <Modal.Title className="vz-file-preview__title">
              {isImage ? "Image Preview" : "File Preview"}
            </Modal.Title>
            <div className="vz-file-preview__subtitle">{title}</div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="vz-file-preview__body p-0">
        {isImage ? (
          <div className="vz-file-preview__viewport">
            <div className="vz-file-preview__frame">
              <img
                src={preview.url}
                alt={title}
                className="vz-file-preview__image"
              />
            </div>
          </div>
        ) : (
          <div className="vz-file-preview__file-card">
            <div className="vz-file-preview__file-icon">
              <i className="fas fa-file-pdf" aria-hidden="true" />
            </div>
            <div className="vz-file-preview__file-name">{fileName}</div>
            <div className="vz-file-preview__file-hint">This file will open in a new browser tab.</div>
            <a
              className="btn vz-file-preview__open-btn"
              href={preview?.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-external-link-alt me-1" aria-hidden="true" />
              Open File
            </a>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="vz-file-preview__footer border-0">
        {preview?.url ? (
          <a
            className="btn btn-outline-primary vz-file-preview__footer-link"
            href={preview.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-external-link-alt me-1" aria-hidden="true" />
            Open in new tab
          </a>
        ) : null}
        <Button variant="outline-secondary" className="vz-file-preview__close-btn" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilePreviewModal;
